import { Link } from "react-router-dom";

import { Typography, WarningIcon } from "~/common/components";
import { ROUTES } from "~/providers/router";

export const CarePlansWarning = () => (
  <div className="flex gap-2">
    <WarningIcon className="size-7" />
    <Typography className="font-light">
      You have not created any care plans. Please add one in your{" "}
      <Link to={ROUTES.carePlans} className="text-primary-600 underline">
        Settings
      </Link>{" "}
      before admitting patient.
    </Typography>
  </div>
);
